import { render, staticRenderFns } from "./deferred-content-placeholder.vue?vue&type=template&id=6696062e&scoped=true"
import script from "./deferred-content-placeholder.vue?vue&type=script&lang=js"
export * from "./deferred-content-placeholder.vue?vue&type=script&lang=js"
import style0 from "./deferred-content-placeholder.vue?vue&type=style&index=0&id=6696062e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6696062e",
  null
  
)

export default component.exports